import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKAtgardLeveransvirkesvolymDTO } from "../../models/atgard-leveransvirkesvolym-models";
import { AtgardLeveransvirkesVolymCommandBase } from "./AtgardLeveransvirkesVolymCommandBase";

export class CreateAtgardLeveransvirkesVolymCommand extends AtgardLeveransvirkesVolymCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateAtgardLeveransvirkesVolymCommand";

    constructor(leveransvirkesvolym: VKAtgardLeveransvirkesvolymDTO, kontraktGuid: string) {
        super(leveransvirkesvolym, CreateAtgardLeveransvirkesVolymCommand.$type, CommandType.Insert);
        this.kontraktGuid = kontraktGuid;
    }
}
